export const prayerTimeSchema = {
  fields: [
    {
      name: 'title',
      label: 'Title',
      type: 'text',
      placeholder: 'Enter prayer title',
      required: true,
    },
    {
      type: 'group',
      name: 'timeDay',
      children: [
        {
          name: 'time',
          label: 'Time of Prayer',
          type: 'tel',
          placeholder: 'HH:MM am/pm',
          required: true,
        },
        {
          name: 'day',
          label: 'Day of Prayer',
          type: 'select',
          placeholder: 'Select day',
          required: true,
          options: [
            { label: 'Monday',    value: 'Monday' },
            { label: 'Tuesday',   value: 'Tuesday' },
            { label: 'Wednesday', value: 'Wednesday' },
            { label: 'Thursday',  value: 'Thursday' },
            { label: 'Friday',    value: 'Friday' },
            { label: 'Saturday',  value: 'Saturday' },
            { label: 'Sunday',    value: 'Sunday' },
          ],
        },
      ],
    },
  ],
  buttons: [
    { label: 'Cancel', action: 'cancel', type: 'button', className: 'btn-back' },
    { label: 'Save Prayer', action: 'save', type: 'button', className: 'btn-next' },
  ],
};
